import { colors } from '@ui/colors'
import { Platform } from 'react-native'
import { hex } from '@ui/utils/hex'
import { BlurMode } from './types'
import { IconName } from '@ui/elements/Icon'

export const DEFAULT_BLUR_OPACITY = Platform.select({ default: 0.5, web: 0.5 })

export const DEFAULT_ONPRESS_BACKGROUND = hex(colors.gray[300], 0.5)

export const DEFAULT_BLUR_MODE: BlurMode = Platform.select({
  default: BlurMode.blurRadius,
  web: BlurMode.backdropFilter,
})

export const iconBlurMode: Record<BlurMode, IconName> = {
  backdropFilter: 'background',
  blurRadius: 'ruler-2',
}
